import { getUserName, httpClient } from "./Service";



export const getAgents = async () => {
    try {
        const result = await httpClient("agent/getall/active", "GET");
        //@ts-ignore
        const agents = result?.data?.agents?.map(({ name, mobile, fare, KG14Rate, KG19Rate, KG5Rate, refillCount, cylinderReceived14KG, cylinderReceived19KG, cylinderReceived5KG }: any) => ({
            label: name,
            value: name,
            fare: fare,
            KG14Rate: KG14Rate,
            KG19Rate: KG19Rate,
            KG5Rate: KG5Rate,
            refillCount: refillCount,
            cylinderReceived14KG: cylinderReceived14KG,
            cylinderReceived19KG: cylinderReceived19KG,
            cylinderReceived5KG: cylinderReceived5KG,
        }));
        return agents;


    } catch (error) {
        console.error("Error in getting agents:", error);
        return { success: false, message: "Error getting agents" };
    }
};
export const getAgent = async (agentName: string) => {
    try {
        const result = await httpClient("agent/connection/get", "POST", { agent: agentName });
        return result;
    } catch (error) {
        console.error("Error in getting agent:", error);
        return { success: false, message: "Error getting agent" };
    }
}

export const fetchPendingConsmer = async () => {
    try {
        const result = await httpClient("agent/pendingcustomer", "POST", {}) as ApiResponse;
        return result?.data?.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

interface ApiResponse {
    data: {
        data: any;
    };
}

export const fetchNewConsumer = async () => {
    try {
        const result = await httpClient("agent/onlyconsumer", "POST", { mainAgent: getUserName() }) as ApiResponse;
        return result?.data?.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

export const manageSingleAadhaar = async () => {
    try {
        const result = await httpClient("agent/onlyconsumer", "POST", { mainAgent: getUserName() }) as ApiResponse;
        return result.data.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

export const manageDoubleAadhaar = async () => {
    try {
        const result = await httpClient("agent/onlyconsumer", "POST", { mainAgent: getUserName() }) as ApiResponse;
        return result.data.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

export const fetchDashBoard = async () => {
    try {
        const result = await httpClient("customer/customerbyagent", "POST", {}) as ApiResponse;
        return result.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const fetchAllCustomer = async () => {
    try {
        const result = await httpClient("agent/allconsumer", "POST", { mainAgent: getUserName() }) as ApiResponse;
        return result.data.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const svreadylistFun = async () => {
    try {
        const result = await httpClient("agent/svreadylist", "POST", { mainAgent: getUserName() });
        return result.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const allSVReadyList = async () => {
    try {
        const result = await httpClient("agent/svreadylist", "POST", {});
        return result.data;

    } catch (error) {
        console.error(error);
    }
};